import { get, writable } from 'svelte/store';
import { isNonProductionAppBuild } from 'src/helpers/dev_tools';
import {
	isLightPriorityDevForce,
	isLightPriorityDevLayout,
	type LightPriorityDevForce,
	type LightPriorityDevLayout,
} from 'src/helpers/light_priority_layout';
import { claimPriorityLayoutDevHud } from 'src/stores/features/dev/priority-layout-dev-hud-state';

const FORCE_KEY = 'shelly_dev_light_priority_force';
const LAYOUT_KEY = 'shelly_dev_light_priority_layout';

const readForce = (): LightPriorityDevForce => {
	if (!isNonProductionAppBuild()) return 'auto';
	try {
		const stored = localStorage.getItem(FORCE_KEY);
		if (isLightPriorityDevForce(stored)) return stored;
	} catch {
		// localStorage may be unavailable
	}
	return 'auto';
};

const readLayout = (): LightPriorityDevLayout => {
	if (!isNonProductionAppBuild()) return 'auto';
	try {
		const stored = localStorage.getItem(LAYOUT_KEY);
		if (isLightPriorityDevLayout(stored)) return stored;
	} catch {
		// localStorage may be unavailable
	}
	return 'auto';
};

export const lightPriorityDevForce = writable<LightPriorityDevForce>(readForce());
export const lightPriorityDevLayout = writable<LightPriorityDevLayout>(readLayout());

lightPriorityDevForce.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(FORCE_KEY, value);
	} catch {
		// localStorage may be unavailable
	}
});

lightPriorityDevLayout.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(LAYOUT_KEY, value);
	} catch {
		// localStorage may be unavailable
	}
});

export const claimLightPriorityDevHud = (): (() => void) => claimPriorityLayoutDevHud('light');

export const getLightPriorityDevForce = (): LightPriorityDevForce =>
	isNonProductionAppBuild() ? get(lightPriorityDevForce) : 'auto';

export const getLightPriorityDevLayout = (): LightPriorityDevLayout =>
	isNonProductionAppBuild() ? get(lightPriorityDevLayout) : 'auto';

export const setLightPriorityDevForce = (force: LightPriorityDevForce) => {
	lightPriorityDevForce.set(isNonProductionAppBuild() ? force : 'auto');
};

export const setLightPriorityDevLayout = (layout: LightPriorityDevLayout) => {
	lightPriorityDevLayout.set(isNonProductionAppBuild() ? layout : 'auto');
};
